import './header';
import './partials/polyfill';
import './partials/ua';
import './partials/download-links';
import './partials/dialog';
import './partials/dmca';
import './partials/popover-download';
import './partials/ga-track';
import { parseQuery } from './partials/utils';

const parsedQs = parseQuery();
const $button = document.querySelector('.landingTz-btn-block-js-start .btn-tv-download-televzr');

if (
  (parsedQs.vid === '690' || parsedQs.vid === '691' || parsedQs.vid === '693') &&
  (parsedQs.utm_source === 'savefrom' || parsedQs.utm_source === 'helper') &&
  (parsedQs.utm_medium === 'vidacha-new' || parsedQs.utm_medium === 'hd-mp3-button') &&
  parsedQs.utm_campaign === 'televzr' &&
  parsedQs.utm_content === 'televzr_integration'
) {
  if (parsedQs.video_id) {
    const videoId = parsedQs.video_id.split('yt-')[1];
    const $under = document.querySelector('.landingTz-video-under');
    const $inner = document.querySelector('.landingTz-video-inner');

    $under.style.backgroundImage = `url('//i.ytimg.com/vi/${videoId}/hqdefault.jpg')`;
    $inner.innerHTML = `<img alt="" src="//i.ytimg.com/vi/${videoId}/hqdefault.jpg">`;
  }
}

$button.addEventListener('click', (event) => {
  if (event.currentTarget.href.indexOf('platform=win') > -1) {
    gtag('event', 'intermediate-page', {
      eventCategory: 'download-inapp',
      type: 'download-for-win-button-click',
    });
  } else if (event.currentTarget.href.indexOf('platform=mac') > -1) {
    gtag('event', 'intermediate-page', {
      eventCategory: 'download-inapp',
      type: 'download-for-mac-button-click',
    });
  }
});
